import { render, staticRenderFns } from "./PromotionalImage.vue?vue&type=template&id=77192408"
import script from "./PromotionalImage.vue?vue&type=script&lang=js"
export * from "./PromotionalImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports